<template>
  <div class="flex flex-col items-baseline md:flex-row md:space-x-8">
    <span class="text-static-default-hi body-1">
      {{ i18n.price(price) }}

      <template v-if="paymentFrequency === 'MONTHLY'">
        {{ i18n(translations.monthlyPayment) }}
      </template>

      <template v-if="paymentFrequency === 'ANNUALLY'">
        {{ i18n(translations.annuallyPayment) }}
      </template>

      <template v-if="paymentFrequency === 'BIANNUALLY'">
        {{ i18n(translations.bienniallyPayment) }}
      </template>
    </span>

    <span v-if="isInUSMarket" class="caption inline-block">
      {{ i18n(translations.cancelAnytime) }}
    </span>

    <span
      v-if="!isInUSMarket && paymentFrequency === 'MONTHLY'"
      class="text-static-default-low caption"
    >
      {{ i18n(translations.oneYearEnrollment, { totalPrice }) }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { InsuranceOffer } from '@backmarket/http-api/src/api-models/InsuranceOffer'
import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import type { Price } from '@backmarket/http-api/src/api-models/Price'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import translations from './InsurancePrice.translations'

const props = defineProps<{
  price: Price
  paymentFrequency: InsuranceOffer['paymentFrequency']
}>()

const marketplace = useMarketplace()
const i18n = useI18n()

const isInUSMarket = computed(
  () => marketplace.market.countryCode === MarketCountryCode.US,
)

const totalPrice = computed(() => {
  return i18n.price({
    amount: (parseFloat(props.price.amount) * 12).toString(),
    currency: props.price.currency,
  })
})
</script>
